import { Alert, Button, Center, PasswordInput, Stack, Text, TextInput, Title } from '@mantine/core';
import { FormEvent, useState } from 'react';
import { api } from '../api';
import { useSession } from '../session';

export function LoginPage() {
  const { refresh } = useSession();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.post('/auth/login', { email, password });
      await refresh();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось войти');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Center mih="100vh" p="md">
      <form onSubmit={submit} style={{ width: '100%', maxWidth: 380 }}>
        <Stack gap="md" className="mis-card" p="xl">
          <div>
            <Title order={2}>Вход</Title>
            <Text c="dimmed" size="sm">Управленческий учёт клиники</Text>
          </div>
          {error && (
            <Alert color="red" variant="light" role="alert">
              {error}
            </Alert>
          )}
          <TextInput label="E-mail" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.currentTarget.value)} />
          <PasswordInput label="Пароль" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.currentTarget.value)} />
          <Button type="submit" size="md" loading={busy}>
            Войти
          </Button>
        </Stack>
      </form>
    </Center>
  );
}
